import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ru from 'vuetify/src/locale/ru.ts';
import en from 'vuetify/src/locale/en.ts';
import IntersectDirective from 'vuetify/lib/directives/intersect';
import ScrollDirective from 'vuetify/lib/directives/scroll';
import TouchDirective from 'vuetify/lib/directives/touch';

import 'roboto-fontface/css/roboto/roboto-fontface.css';

import '@mdi/font/css/materialdesignicons.css';

import '@fortawesome/fontawesome-free/css/all.css';

export function createVuetify({isDark = false}) {
  // Vuetify.config.silent = true;

  Vue.use(Vuetify);

  Vue.directive('intersect', IntersectDirective);
  Vue.directive('scroll', ScrollDirective);
  Vue.directive('touch', TouchDirective);

  return new Vuetify({
    theme: {
      options: {
        customProperties: true,
      },
      themes: {
        light: {
          primary: '#726897',
          secondary: '#413964',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
        },
        dark: {
          primary: '#726897',
          secondary: '#413964',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
        },
      },
      dark: isDark,
    },
    lang: {
      locales: { ru, en },
      current: 'ru',
    },
    icons: {
      // https://stackoverflow.com/questions/57492749/font-awesome-svg-icons-not-working-with-vuetify
      // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
      // iconfont: 'mdiSvg',
      iconfont: 'faSvg',
    },
  });
}

export default {
  createVuetify,
};

